import axios from 'axios'
/**
 * PDFダウンロード
 * Axiosで対象ファイルをGetし、aタグを生成してダウンロード
 * @param {String} fileName ファイル名
 * @return void
 */
export default function fileDownload(fileName) {
  console.log(fileName)
  axios({
    url: `https://materials.strail-english.jp/pdf/${fileName}.pdf`,
    method: 'get',
    responseType: 'blob'
  })
    .then(res => {
      // バイナリデータとして処理
      const blob = new Blob([res.data], {
        type: res.data.type
      })
      // aタグを作成してダウンロードを実行させる
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)

      link.setAttribute('download', `${fileName}.pdf`)
      document.body.appendChild(link)
      link.click()
    })
    .catch(error => console.log(error))
}